/* eslint-disable react/jsx-props-no-spreading */

import React from "react";

// eslint-disable-next-line react/prop-types
function AddIcon({ width = 20, height = 20, color, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* SourceOutlined icon from Material UI */}
      <g id="SourceOutlined">
        <path
          d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-2-6H6v2h12v-2zm0 4H6v2h12v-2z"
          fill={color || "currentColor"}
        />
      </g>
    </svg>
  );
}

export default AddIcon;
